'use strict';/* global define:false */define('modules/notes/directives/notes-panel/controller',[],function(){'use strict';// @ngInject
     controller.$inject = ["$scope", "$filter", "Notes", "Modals", "Toaster"];
function controller($scope,$filter,Notes,Modals,Toaster){// jshint validthis:true
// jshint latedef:false
var ctrl=this;var translate=$filter('translate');ctrl.addNote=addNote;ctrl.removeNote=removeNote;// ---
/**
     * Add a note
     *
     * @param {Object} note - Note to be added
     */function addNote(note){note.$promise.then(function(note){$scope.notes.push(note);});}/**
     * Remove a note
     *
     * @param  {String} confirmKey - Translation key for confirm modal
     * @param  {String} successKey - Translation key for successful deletion
     * @param  {Object} note       - Note to be removed
     *
     * @tested
     */function removeNote(confirmKey,successKey,note){var confirmMsg=translate(confirmKey);Modals.confirm(confirmMsg,function(){Notes.delete(ctrl.type,note,$scope.notes).$promise.then(function(){Toaster.success(translate(successKey));}).catch(Modals.fail);});}}return controller;});
